package com.wintermar.inspection.feature.data.repository

import com.apollographql.apollo.ApolloClient
import com.wintermar.inspection.core.data.AuthRefreshApi
import com.wintermar.inspection.feature.data.remote.request.HeaderRequest
import com.wintermar.inspection.graphql.RefreshTokenMutation

class AuthRefreshClient(
    private val apolloClient: ApolloClient,
) : AuthRefreshApi {
    override suspend fun refresh(authorizationHeader: String): Result<Pair<String?, String?>> {
        return try {
            val response = apolloClient
                .mutation(RefreshTokenMutation())
                .addHttpHeader(HeaderRequest.AUTHORIZATION, authorizationHeader)
                .execute()

            val data = response.data?.refreshToken

            Result.success(Pair(data?.loginToken, data?.refreshToken))
        } catch (t: Throwable) {
            Result.failure(t)
        }
    }
}
